<template lang="pug">
  active-item(:is-active="$mq === 'mobile'")
    .dropdown.relative.inline-block.w-full.mr-6(:class="{active: active}" slot-scope="{ setActive, active }"  v-click-outside="() => { if ($mq === 'desktop') return setActive(false) }")
      .dropdown__btn.w-full.border-2.border-gray-400.relative.text-base.text-gray.font-normal.py-select.pl-8.pr-16.text-left.inline-block.rounded.leading-10.overflow-hidden(class="hidden xl:block" @click.prevent="if ($mq === 'desktop') setActive(!active); return") {{ label }}

      collapse-transition
        .dropdown__menu.w-full.rounded.top-dropdown.bg-white.left-0.z-40.pb-10.px-12(class="xl:min-w-dropdown-budget xl:py-8 xl:shadow xl:w-auto xl:absolute" v-show="active")
          p.title-400.mb-6 Budget
          .grid.grid-cols-2.gap-4
            .form-group
              .form-icon-wrapper
                input-cleave.form-control(placeholder="Min" type="text" v-model="minBudget")
                span.form-control__icon.fal.fa-euro-sign.text-base
            .form-group
              .form-icon-wrapper
                input-cleave.form-control(placeholder="Max" type="text" v-model="maxBudget")
                span.form-control__icon.fal.fa-euro-sign.text-base
</template>

<script>
import { debounce } from 'lodash'
import InputCleave from '@components/InputCleave'

export default {
  components: { InputCleave },

  props: {
    searchParams: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      minBudget: this.searchParams.by_min_price || this.searchParams.by_min_rent,
      maxBudget: this.searchParams.by_max_price || this.searchParams.by_max_rent,
      label: 'Budget'
    }
  },

  computed: {
    mutableProperties () {
      return this.minBudget, this.maxBudget, Date.now() // eslint-disable-line
    }
  },

  watch: {
    mutableProperties: debounce(function () {
      if (parseInt(this.minBudget) === 0 || this.minBudget === '') {
        this.$store.commit('deleteParams', 'by_min_price')
      } else {
        this.$store.commit('updateParams', { key: 'by_min_price', value: this.minBudget })
      }

      if (parseInt(this.maxBudget) === 0 || this.maxBudget === '') {
        this.$store.commit('deleteParams', 'by_max_price')
      } else {
        this.$store.commit('updateParams', { key: 'by_max_price', value: this.maxBudget })
      }

      this.$store.dispatch('searchAccommodations')
        .then(({ budgetizeLabel }) => {
          this.label = budgetizeLabel
        })
        .catch((e) => {
          console.debug(e.message)
        })
    }, 300)
  },

  mounted () {
    this.$nextTick(() => {
      this.$store.commit('updateReady', 'budgetRange')
    })
  }
}
</script>
